import useFetch from '../hooks/useFetch'

export default () => {
  const fetch = useFetch()

  const parseErrorMessageFromJson = (response, jsonData = {}) => {
    const { error = 'error' } = jsonData;
    throw new Error(`/auth/me error: ${response.status} ${error}`);
  }

  const fetchMe = async () => {
    try {
      const response = await fetch('auth/me', { method: 'GET' })
      if (response.ok) {
        const jsonData = await response.json()
        if (jsonData.error) {
          parseErrorMessageFromJson(response, jsonData)
        }
        return jsonData;
      } else {
        const jsonData = await response.json()
        parseErrorMessageFromJson(response, jsonData)
      }
    } catch (e) {
      const msg = (e && e.message) || String(e)
      console.log(msg)
      return {}
    }
  }

  return {
    fetchMe
  }
}